import React from 'react';
import PropTypes from 'prop-types';
import { compose, withProps } from 'recompose';
import classnames from 'classnames';
import { isEmpty } from 'lodash';

import { H2 } from 'components/core/Typography';
import { AccordionItem } from 'components/search/Accordion';

import './accordion.scss';

export const enhance = compose(
	withProps(({ content, isFAQ }) => {
		let faqSchema = {};
		if (isFAQ) {
			faqSchema = {
				'@context': 'http://schema.org',
				'@type': 'FAQPage',
				mainEntity: content.map((faq) => ({
					'@type': 'Question',
					name: faq.title,
					acceptedAnswer: {
						'@type': 'Answer',
						text: faq.copy,
					},
				})),
			};

			faqSchema = JSON.stringify(faqSchema);
		}
		return { faqSchema };
	}),
);

export function Accordion({
	className,
	accordionTitle,
	content,
	faqSchema,
	isFAQ,
	preserve,
}) {
	return (
		<div className={classnames(className, 'accordion')}>
			<H2
				size="medium"
				className="accordion-title"
			>
				{accordionTitle}
			</H2>
			<div>
				{content.map(({ title, copy, link }) => (
					<AccordionItem
						title={title}
						copy={copy}
						link={link}
						key={title}
						isFAQ={isFAQ}
						preserve={preserve}
					/>
				))}
			</div>
			{!isEmpty(faqSchema) && (
				<script
					key="schema"
					type="application/ld+json"
					// eslint-disable-next-line react/no-danger
					dangerouslySetInnerHTML={{
						__html: faqSchema,
					}}
				/>
			)}
		</div>
	);
}

Accordion.propTypes = {
	className: PropTypes.string,
	accordionTitle: PropTypes.string,
	content: PropTypes.arrayOf(PropTypes.object),
	faqSchema: PropTypes.string,
	isFAQ: PropTypes.bool,
	preserve: PropTypes.bool,
};

Accordion.defaultProps = {
	content: [],
	preserve: false,
};

export default enhance(Accordion);
